const strapiConfig = {
    baseURL: 'https://smiling-prosperity-fe7d3c9c1c.strapiapp.com/api',
    auth: 'd9e6cd5f0557298f5fab63c45240a03c3fd53e99d73657287840621501e8f8bf1701a163db9fdf9ee8692cbc8725036640547ce50a0fe8b3cbb42d14975ea1f8e747b2679e424bcb841ff98d882f016e9bfcc98120bed7ab6d32f09330b9ce914d0ce190a88bcafde685b95ccf6c5402260f4e6bd14ad47e983cf8d749d076d5',
};
  
  export default strapiConfig;
  